import moment from 'moment-timezone'
import store from '../store'

// TODO Move timezone from account to user. TZ is not used when storing from backend at account level (UTC is used), so users should be able to set the zone they prefer. 
function formatDate(date) {
    // check account for TZ first, if any changes have been made since login it will be populated, else get from login profile
    if (date) {
      var tz = store.getters.getAccount.timeZone ? store.getters.getAccount.timeZone : store.getters.getProfile.timeZone
      if(tz){
        return moment(date).tz(tz).format("M/D/yyyy");
      } else {
        return moment(date).format("M/D/yyyy");
      }
    }
}

function formatDateTime(date) {
    // check account for TZ first, if any changes have been made since login it will be populated, else get from login profile
    if(date){
        var tz = store.getters.getAccount.timeZone ? store.getters.getAccount.timeZone : store.getters.getProfile.timeZone
        if (tz) {
            return moment.utc(date).tz(tz).format("M/D/yyyy h:mm A")
        } else {
            return moment.utc(date).format("M/D/yyyy h:mm A")
        }
    }
}

function isValidDate(dateString) {
    // expects date format yyyy-MM-dd, ISO_LOCAL_DATE
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false; // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === dateString;
}

function dateRangeFormatted(startDate, endDate){
    if(startDate != null && endDate != null){
        return moment(startDate).format("M/D/yyyy") + " thru " + moment(endDate).format("M/D/yyyy");
    } else {
        return "";
    }
    
}

function getMinDateString(){
    return new Date().toISOString().substr(0, 10);
}

export { formatDateTime, formatDate, isValidDate, dateRangeFormatted, getMinDateString}